import { defineMessages } from 'react-intl'

export const connectedAppsMessages = defineMessages({
  title: {
    id: 'connectedApps.title',
    description: 'Connected apps page title',
    defaultMessage: 'Connected Apps',
  },
  active: {
    id: 'connectedApps.active',
    description: 'Label for connected apps active status',
    defaultMessage: 'Active',
  },

  inactive: {
    id: 'connectedApps.inactive',
    description: 'Label for connected apps inactive status',
    defaultMessage: 'Inactive',
  },
  buttonTextRevoke: {
    id: 'connectedApps.buttonTextRevoke',
    description: 'Button text for connected apps active status',
    defaultMessage: 'Revoke',
  },

  buttonTextActivate: {
    id: 'connectedApps.buttonTextActivate',
    description: 'Button text for connected apps inactive status',
    defaultMessage: 'Activate',
  },
  noActiveApps: {
    id: 'connectedApps.noActiveApps',
    description: 'Text which is shown when there are no active apps',
    defaultMessage: "You currently don't have main apps installed.",
  },
})
